export default "__VITE_ASSET__BGP7L4Ni__"